export default __webpack_public_path__ + "f95c5f8bd99d27d384ab823552613f2b.png";